function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis from '@/services/services';
import tasks from '@/js/tasks';
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};

/**
 * getRecords takes any argument.
 * @param {String} table_name table name
 * @param {Number} record_id  record identifier
 * @return {Object} Record depends on the table_name and record_id
 */
appApis.getRecords = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var record_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var login = loginObj();
  var params = _objectSpread({
    record_id: record_id
  }, login);
  return appApis.get("/dp/".concat(table_name), {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * postRecord takes any argument.
 * @param {String} table_name table name to create a new record
 * @param {Object} values values to save dependes on table_name
 * @return {Object} Status of th process
 */
appApis.postRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var login = loginObj();
  var params = {
    login: login,
    values: values
  };
  return appApis.post("/dp/".concat(table_name), params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putRecord takes any argument.
 * @param {String} table_name table name to write
 * @param {Object} values values to write
 * @param {Object} oldValues old values to save in log table
 * @return {Object} Status of th process
 */
appApis.putRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var oldValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var login = loginObj();
  var params = {
    login: login,
    values: values,
    oldValues: oldValues
  };
  return appApis.put("/dp/".concat(table_name), params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * deleteRecord takes any argument.
 * @param {String} table_name table name to delete
 * @param {Number} record_id record identifier to delete
 * @return {Object} Status of th process
 */
appApis.deleteRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var record_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var login = loginObj();
  var params = _objectSpread({
    record_id: record_id
  }, login);
  return appApis.delete("/dp/".concat(table_name), {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * getUserprofileTable takes any argument.
 * @return {Object} Table details grouped by area_id and userprofile_id
 */
appApis.getUserprofileTable = function () {
  var login = loginObj();
  var params = _objectSpread({}, login);
  return appApis.get("/dp/userprofile_table", {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * getUserprofileTableDetail takes any argument.
 * @param {Number} area_id  area_id of table to delete
 * @param {Number} userprofile_id userprofile_id of table to delete
 * @return {Object} Table details filtered by area_id and userprofile_id
 */
appApis.getUserprofileTableDetail = function (area_id, userprofile_id) {
  var login = loginObj();
  var params = _objectSpread({
    area_id: area_id,
    userprofile_id: userprofile_id
  }, login);
  return appApis.get("/dp/user_profile_table_detail", {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putUserprofileTable takes any argument.
 * @param {Object} values
 * {
 *    toUpdate: Records to update
      toCreate: Records to create
      toDelete: Records to delete
 * }
 * @return {Object} Status of th process
 */
appApis.putUserprofileTable = function () {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var params = {
    login: login,
    values: values
  };
  return appApis.put("/dp/user_profile_table_detail", params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * deleteUserprofileTableDetail takes any argument.
 * @param {Number} area_id  area_id of table to delete
 * @param {Number} userprofile_id userprofile_id of table to delete
 * @return {Object} Status of th process
 */
appApis.deleteUserprofileTableDetail = function (area_id, userprofile_id) {
  var login = loginObj();
  var params = _objectSpread({
    area_id: area_id,
    userprofile_id: userprofile_id
  }, login);
  return appApis.delete("/dp/user_profile_table_detail", {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * downloadProfileAssignment takes any argument.
 * @return {Object} Download records (crossing of allocation tables with table detail)
 */
appApis.downloadProfileAssignment = function () {
  var login = loginObj();
  var params = _objectSpread({}, login);
  return appApis.get("/dp/download_profile_assignment", {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * getInitialSetup takes any argument.
 * @return {Object} Tables to which you have permission according to the logged in user
 */
appApis.getInitialSetup = function () {
  var login = loginObj();
  var params = _objectSpread({}, login);
  tasks.lockScreen.lock();
  return appApis.get("/dp/initial_setup", {
    params: params
  }).then(function (response) {
    tasks.lockScreen.unlock();
    return response['data'];
  }).catch(function (error) {
    tasks.lockScreen.unlock();
    console.error(error);
  });
};

/**
 * postInitialSetup takes any argument.
 * @param {Object} values
 * {
 *    id: record id,
 *    supervisor: supervisor mail
 *    area_id: area to which the applicant belongs
 *    userprofile_id: the applicant's profile
 *    applicant: applicant mail
 * }
 * @return {Object} Status of th process
 */
appApis.postInitialSetup = function (values) {
  var login = loginObj();
  var params = _objectSpread(_objectSpread({}, login), values);
  return appApis.post("/dp/initial_setup", params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putInitialSetup takes any argument.
 * @param {Object} values values to write(depends on the values that was edited)
 * @return {Object} Status of th process
 */
appApis.putInitialSetup = function (values) {
  var login = loginObj();
  var params = _objectSpread(_objectSpread({}, login), values);
  tasks.lockScreen.lock();
  return appApis.put("/dp/initial_setup", params).then(function (response) {
    tasks.lockScreen.unlock();
    return response['data'];
  }).catch(function (error) {
    tasks.lockScreen.unlock();
    console.error(error);
  });
};

/**
 * getMassiveRequests takes any argument.
 * @return {Object} Rercords of massive requests
 */
appApis.getMassiveRequests = function () {
  var login = loginObj();
  var params = _objectSpread({}, login);
  tasks.lockScreen.lock();
  return appApis.get("/dp/massive_requests", {
    params: params
  }).then(function (response) {
    tasks.lockScreen.unlock();
    return response['data'];
  }).catch(function (error) {
    tasks.lockScreen.unlock();
    console.error(error);
  });
};

/**
 * getMassiveRequests takes any argument.
 * @return {Object} Rercords of massive requests
 */
appApis.getMassiveRequestsDetail = function (data) {
  var login = loginObj();
  var params = _objectSpread(_objectSpread({}, login), data);
  return appApis.get("/dp/massive_requests_detail", {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putMassiveRequests takes any argument.
 * @param {Object} values values to write(depends on the values that was edited)
 * @return {Object} Status of th process
 */
appApis.putMassiveRequests = function (values) {
  var login = loginObj();
  var params = _objectSpread(_objectSpread({}, login), values);
  return appApis.put("/dp/massive_requests", params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * hideInitialSetupMenu takes any argument.
 * @return {Object} Status of th process
 */
appApis.hideInitialSetupMenu = function () {
  var login = loginObj();
  var params = _objectSpread({}, login);
  if (!params.email) {
    return new Promise(function (resolve, reject) {
      resolve();
      return true;
    });
  } else {
    return appApis.get("/dp/hide_initial_setup", {
      params: params
    }).then(function (response) {
      return response['data'];
    }).catch(function (error) {
      console.error(error);
    });
  }
};
export default appApis;